import React from 'react';
import {
    SwipeableDrawer,
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    styled,
    Typography,
} from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import ErrorIcon from '@mui/icons-material/Error';
const validPermission = 'update:schoolProfile';
const certifiedPermission = 'create:availability';

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#fefefe',
}));
export const MobileDrawer = props => {
    const profile = useSelector(state => state.profile.profile);
    const profileStatus = useSelector(state => state.profile.status);
    const tokenStatus = useSelector(state => state.token.status);

    const { token } = useSelector(state => state.token);
    const [open, setOpen] = React.useState(false);

    const [state, setState] = React.useState({
        schoolAdmin: false,
        fullVerification: false,
    });
    React.useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            let schoolAdminTemp = false;
            let certifiedPermissionTemp = false;

            if (token.permissions.includes(validPermission)) {
                schoolAdminTemp = true;
            }

            if (token.permissions.includes(certifiedPermission)) {
                certifiedPermissionTemp = true;
            }

            setState({
                ...state,
                schoolAdmin: schoolAdminTemp,
                fullVerification: certifiedPermissionTemp,
            });
        }
    }, [tokenStatus, token.Count, token.permissions]);

    const { logout } = useAuth0();

    return (
        <SwipeableDrawer
            anchor="left"
            open={props.open}
            onClose={props.toggleClose}
            onOpen={props.toggleOpen}
            swipeAreaWidth={0}
            disableSwipeToOpen={false}
            ModalProps={{
                keepMounted: true,
            }}
        >
            <StyledBox
                sx={{
                    px: 2,
                    py: 1,
                    height: '100%',
                    overflow: 'auto',
                    background:
                        'linear-gradient(130deg, #4632DA 0%, #06D9FA 90%)',
                    color: '#FFFEFE',
                    minWidth: '250px',
                }}
            >
                <Box>
                    {profileStatus === 'succeeded' &&
                        profile.Data.Count > 0 && (
                            <List
                                sx={{
                                    color: '#FFFEFE',
                                }}
                            >
                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                    }}
                                >
                                    <ListItemButton
                                        component="a"
                                        href="/action"
                                    >
                                        <ListItemText
                                            primary="Actions"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                    }}
                                >
                                    <ListItemButton
                                        component="a"
                                        href="/history"
                                    >
                                        <ListItemText
                                            primary="History"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                {state.fullVerification && (
                                    <>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/teacher-availability"
                                            >
                                                <ListItemText
                                                    primary="Availability"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    </>
                                )}
                                {profile.Data.Items[0].type === 'Teacher' &&
                                    state.fullVerification && (
                                        <>
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/jobs"
                                                >
                                                    <ListItemText
                                                        primary="Jobs"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        </>
                                    )}
                                {profile.Data.Items[0].type === 'School' &&
                                    state.schoolAdmin === true && (
                                        <>
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/book-teacher"
                                                >
                                                    <ListItemText
                                                        primary="Book Teacher"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/casual-relief-teacher-list"
                                                >
                                                    <ListItemText
                                                        primary="Saved Teachers"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/jobs"
                                                >
                                                    <ListItemText
                                                        primary="School Jobs"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        </>
                                    )}
                                {/*school*/}
                                <Box
                                    sx={{
                                        width: '100%',
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        marginBottom: '5px',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height: '.8px',
                                            width: '100%',
                                            zIndex: '1',
                                            background: '#fff',
                                            position: 'absolute',
                                        }}
                                    ></Box>

                                    <Typography
                                        sx={{
                                            color: '#FFF',
                                            zIndex: '2',
                                            fontSize: '.8rem',
                                            mt: 3,
                                            marginLeft: 1.2,
                                        }}
                                    >
                                        Profile
                                    </Typography>
                                </Box>
                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                    }}
                                >
                                    <ListItemButton
                                        component="a"
                                        href="/profile/userInfo"
                                    >
                                        <ListItemText
                                            primary="General"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                {profile.Data.Items[0].type === 'School' && (
                                    <div>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/schoolInfo"
                                            >
                                                <ListItemText
                                                    primary="School Information"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/teacherList"
                                            >
                                                <ListItemText
                                                    primary="School Teachers"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/staffNeeds"
                                            >
                                                <ListItemText
                                                    primary="Staffing Needs"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/network"
                                            >
                                                <ListItemText
                                                    primary="School Network"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>

                                        {state.schoolAdmin === true && (
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/profile/billing"
                                                >
                                                    <ListItemText
                                                        primary="Billing Information"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </div>
                                )}
                                {/*teacher*/}
                                {profile.Data.Items[0].type === 'Teacher' && (
                                    <div>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/skills"
                                            >
                                                <ListItemText
                                                    primary="Skills"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                paddingX: '15px',
                                            }}
                                        >
                                            <ListItemButton
                                                component="a"
                                                href="/profile/network"
                                            >
                                                <ListItemText
                                                    primary="Network"
                                                    sx={{
                                                        '& span': {
                                                            color: '#FFFEFE',
                                                        },
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        {state.fullVerification ? (
                                            <>
                                                <ListItem
                                                    disablePadding
                                                    sx={{
                                                        paddingX: '15px',
                                                    }}
                                                >
                                                    <ListItemButton
                                                        component="a"
                                                        href="/profile/documents"
                                                    >
                                                        <ListItemText
                                                            primary="Documents"
                                                            sx={{
                                                                '& span': {
                                                                    color: '#FFFEFE',
                                                                },
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                            </>
                                        ) : (
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    paddingX: '15px',
                                                }}
                                            >
                                                <ListItemButton
                                                    component="a"
                                                    href="/profile/documents"
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: '30px',
                                                        }}
                                                    >
                                                        <ErrorIcon />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary="Documents"
                                                        sx={{
                                                            '& span': {
                                                                color: '#FFFEFE',
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </div>
                                )}

                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                    }}
                                >
                                    <ListItemButton
                                        component="a"
                                        href="/profile/invitations"
                                    >
                                        <ListItemText
                                            primary="Invitations"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                        display: 'none',
                                    }}
                                >
                                    <ListItemButton
                                        component="button"
                                        href="#settings"
                                    >
                                        <ListItemText
                                            primary="Settings"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem
                                    disablePadding
                                    sx={{
                                        paddingX: '15px',
                                    }}
                                >
                                    <ListItemButton
                                        component="button"
                                        onClick={() => {
                                            logout({
                                                returnTo:
                                                    window.location.origin,
                                            });
                                        }}
                                    >
                                        <ListItemText
                                            primary="Logout"
                                            sx={{
                                                '& span': {
                                                    color: '#FFFEFE',
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        )}
                </Box>
            </StyledBox>
        </SwipeableDrawer>
    );
};
export default MobileDrawer;
